export const routes = [
  ...require('./service-request-list/routes').routes,
  ...require('./send-email-sms/routes').routes,
  ...require('./comunication-history/routes').routes

]
